module.exports = __webpack_public_path__ + "images/referenzen/interviews/elbstrand_retten_imagefilm.jpg";